define('ua/listeners/quote',[
    'ua/ua-wrapper',
    'ua/ua-config',
    'doneable',
    'adlhelpers',
    'domhelpers',
    'edapUnderscore'
], function(ua, config, Doneable, ADL, domHelpers, _) {
    'use strict';

    /**
     * EVENTS:
     *  quote.attempt
     *  quote.success
     *  quote.failure
     *
     */
    function setupListeners(edap) {
        // TECHDEBT: property attributes event should be deprecated when we're able
        function sendPropertyAttributes(data) {
            var adl = new ADL(data),
                listingid;

            if (adl.shouldSet(adl.getListingIds())) {
                listingid = adl.getListingIds();
            } else {
                listingid = adl.get('propertyid');
            }

            if (data && adl.shouldSet(data.propertydetails) && adl.shouldSet(listingid)) {
                return ua.sendEvent(
                    'property attributes',
                    listingid,
                    adl.get('propertydetails'),
                    undefined,
                    undefined,
                    data
                );
            }

            return new Doneable();
        }

        function trackQuote(data, quoteType, done) {
            // copy data obj since we don't want the following changes affecting other EDAP listeners
            var dataCopy = _.clone(data);

            // Override pagetype, pagename, pageurl for all of these on both the VPV and property attributes event for historical reasons
            // We do this to make sure only 1 PV has a pagetype='property' for reporting
            if (dataCopy.pagetype === 'property') {
                dataCopy.pagetype = 'booking';
                dataCopy.pagename = 'traveler ' + quoteType;
                dataCopy.pageurl = config.staticVPVs[quoteType];
            } else {
                dataCopy.pagetype = dataCopy.pagetype + ' ' + quoteType;
                dataCopy.pagename = dataCopy.pagename + ' ' + quoteType;
                dataCopy.pageurl = domHelpers.getPage() + '/' + quoteType;
            }

            Doneable.all([
                ua.sendInteractionPageview(dataCopy, dataCopy.pageurl), // don't need to pass pagetype since we set it above
                sendPropertyAttributes(dataCopy)
            ]).then(done);
        }

        edap.on('quote.attempt', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quoteattempt', done);
        });

        edap.on('quote.success', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quotesuccess', done);
        });

        edap.on('quote.failure', function(data, setAsync, done) {
            setAsync();

            trackQuote(data, 'quotefailure', done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

